import axios from "axios";
import ParkingToolSpace from "./ParkingToolTypes";

const ParkingToolService = {
  get: {
    locations: (tenant: string, t: any) => {
      const user: any = JSON.parse(localStorage.getItem("user") || "");

      const addLocation = (location: any, type: "compound" | "mobilityStore") => {
        const locType = type === "compound" ? t("parkingTool.locationType.compound") : t("parkingTool.locationType.lms");
        const name = `${location.name} (${locType})`;
        
        return {
          ...location,
          name,
          type: locType,
          bpCode: location.bpCode,
          sapId: location.bpCode,
          tenant: location.tenant,
          typeEnum: type === "compound" ? "COMPOUND" : "LMS",
          key: `${location.bpCode}-${type === "compound" ? "COMPOUND" : "LMS"}`,
        }
      }

      const mobilityStores = user.mobilityStores?.map((ms: any) => ({
        ...addLocation(ms, "mobilityStore"),
      }));
      
      const logisticCompounds = user.logisticCompounds?.map((ms: any) => ({
        ...addLocation(ms, "compound"),
      }));

      let dataToReturn: any = [];
      !!mobilityStores && dataToReturn.push(...mobilityStores?.filter((element: any) => element.tenant === tenant));
      !!logisticCompounds && dataToReturn.push(...logisticCompounds?.filter((element: any) => element.tenant === tenant));
      return Promise.resolve(dataToReturn);
    }
  },
  post: {
    getAvailabilityForParkingTool: (tenant: string, request: ParkingToolSpace.Request) => {
      return axios.post<ParkingToolSpace.Response>(`parkingtool/getAvailabilityForParkingTool`, request, {
        params: { tenant }
      }).then(
        response => response.data,
        error => error.response,
      )
    }
  }
}

export default ParkingToolService;